import { getLocale } from '@/helpers/url'

export const DOMAIN = 'on-running.com'
export const CUSTOMER_SERVICE_SUBDOMAIN = `customer-service.${DOMAIN}`
export const FILTER_PAGE_PATH = 'explore'
export const FILTER_PAGE_MENS_PATH = 'explore/mens'
export const FILTER_PAGE_WOMENS_PATH = 'explore/womens'
export const SHOE_FINDER_PATH = 'shoe-finder'
export const SHIPPING_RETURNS_PATH = 'shipping_and_returns'
export const RAFFLE_FAQ_PATH = 'articles/faq-the-roger-clubhouse-prerelease'
export const SIZE_GUIDE_PATH = 'size_guide'
export const ORDER_STATUS_PATH = 'order-status'
export const RETURNS_DIRECT_PATH = 'returns/direct'
export const PDP_ROGER_PATH = 'products/theroger-centre-court'

export const getOrderStatusDirectPath = id => `${ORDER_STATUS_PATH}?id=${id}`
export const getReturnsDirectPath = id => `${RETURNS_DIRECT_PATH}?order=${id}`

export function getGraphqlEndpointUrl() {
  const hostname = window.location.origin
  const locale = getLocale(window.location.pathname)
  const localeUrl = locale ? `/${locale}` : ''
  return `${hostname}${localeUrl}/graphql`
}

export const getBestsellersExplorePath = (...subPaths) => {
  const pathSubUrl = subPaths.reduce((path, subPath) => {
    return subPath ? path + `/${subPath}` : path
  }, '')

  return `/${FILTER_PAGE_PATH}${pathSubUrl}?sort=bestseller`
}
